import {
  Alert,
  alertClasses,
  formControlLabelClasses,
  RadioGroup,
  styled,
} from "@mui/material";

const Header = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 0px 20px;
`;

const DrawerBody = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 20px 20px 20px;
`;

const Group = styled(RadioGroup)`
  width: 100%;
  & .${formControlLabelClasses.root} {
    margin: 0px;
    color: #333333;
  }
  & > *:not(:last-child) {
    border-bottom: 1px solid lightgray;
  }
  & > * {
    padding: 8px;
  }
`;

const Note = styled(Alert)`
  &.${alertClasses.root} {
    background-color: #f4f4f4;
    color: #333333;
    width: 100%;
  }
  & .${alertClasses.icon} {
    color: #333333;
  }
`;

export { Header, DrawerBody, Group, Note };
